import { isEmpty } from 'lodash';

import constructImageURLsForVariant from 'commons/constructImageURLsForVariant';
import categoryAngles from 'commons/category-angles.json';
import { IMAGE_SKU_OPTION_IDS } from 'commons/constants';

const category2Order = [2, 3, 4, 5, 1];
const category1Order = [1, 2, 3, 4, 5];

export const getOptionFromOptionName = (options, optionName) => {
  if (!optionName || !options) {
    return null;
  }
  return options.find(option => option.name === optionName);
};

export const getOptionValueFromValueName = (option, valueName) => {
  if (!valueName || !option) {
    return null;
  }
  return option.values.find(value => value.value === valueName);
};

// An image SKU includes a combination of options like a variant SKU, but only
// includes options that are relevant to the image.
const getImageSkuFromSelectedOptions = selectedOptionsExtended =>
  Object.keys(selectedOptionsExtended)
    .filter(optionIdKey =>
      IMAGE_SKU_OPTION_IDS.includes(parseInt(optionIdKey, 10))
    )
    .map(optionIdKey => selectedOptionsExtended[optionIdKey].value.sku)
    .join('');

export const getConfigPhotosForSelectedOptions = (
  selectedOptionsVariantSku,
  selectedOptionsExtended,
  upholsteryOptionId,
  basicDetails
) => {
  const selectedOptionsImageSku = getImageSkuFromSelectedOptions(
    selectedOptionsExtended
  );

  const finalImageOrder =
    basicDetails?.type?.name &&
    categoryAngles[basicDetails.type.name.toLowerCase()] &&
    categoryAngles[basicDetails.type.name.toLowerCase()] === 2
      ? category2Order
      : category1Order;
  const finalArrayFrom = !isEmpty(
    basicDetails?.variation_photos_count?.[selectedOptionsImageSku]
  )
    ? Array.from(
        Array(basicDetails.variation_photos_count[selectedOptionsImageSku])
      )
    : finalImageOrder;
  const images = basicDetails?.id
    ? finalArrayFrom
        .map((_, idx) => {
          // Use finalImageOrder till 5th place
          const angle = idx < 5 ? finalImageOrder[idx] : idx + 1;
          return constructImageURLsForVariant(
            basicDetails.id,
            selectedOptionsImageSku,
            basicDetails.name,
            selectedOptionsExtended?.[upholsteryOptionId]?.value?.value,
            angle,
            null,
            true
          );
        })
        .map(({ transparent_config_image }) => transparent_config_image)
        .map(url => ({ id: url, src: url, type: 'configuration' }))
    : [];
  return images;
};
